import request from '@/utils/request'

export function selectStainlessCarvingSet(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/stainlessSteelCarvingSet/selectStainlessCarvingSet?access=${data}`,
        method: 'post',
       // data,
    })
}

export function upDateStainlessCarvingSet(data) {
    return request({
        url: `api/serviceCenter/stainlessSteelCarvingSet/upDateStainlessCarvingSet`,
        method: 'post',
        data,
    })
}

export function bathDeleteStainlessCarving(data) {
    return request({
        url: `api/serviceCenter/stainlessSteelCarvingSet/bathDeleteStainlessCarving`,
        method: 'post',
        data,
    })
}
